import React, { useEffect, useState } from "react";
import { ArraySelectInput, TextInput } from "./EditPopup";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import { postGroupAction } from "./functions";
import PromptElement from "../../PromptElement";
import ConfirmPopup from "./ConfirmEdit";
import { setAppError } from "../../../../store/userSlice";

export default function GroupActionPopup({
  popupState,
  setPopupState,
  setTableData,
  checkedList = [],
  arrivalBatchId,
  groupDownloadPopupStateDocument,
}) {
  const dispatch = useDispatch();
  console.log(
    "checkedList.........123456......",
    checkedList,
    arrivalBatchId,
    groupDownloadPopupStateDocument
  );
  const [finalObj, setFinalObj] = useState({});
  const [disable, setDiasble] = useState(true);

  const [submitLoading, setSubmitLoading] = useState(false);

  const [showConfirmEditPopup, setShowConfirmEditPopup] = useState(false);

  const handleGroupEdit = async (e, editConfirmed = false) => {
    if (e) e?.preventDefault();
    if (popupState.type == "status" && !editConfirmed) {
      setShowConfirmEditPopup(true);
      return;
    }

    const body = {
      type: popupState.type,
      candidate: [],
    };
    let check = groupDownloadPopupStateDocument.filter((value) =>
      checkedList.includes(value.id)
    );
    const currentDate = new Date();

    // Function to convert the arrival date from "dd-mm-yyyy" or ISO format to a Date object
    const parseDate = (dateStr) => {
      if (!dateStr) return null;
      console.log(".......dateStr.......", dateStr);
      
      let date;
      if (typeof dateStr === "string" && (dateStr.includes("T") || dateStr.includes(":"))) {
        date = new Date(dateStr);
      } else if (typeof dateStr === "string" && dateStr.includes("-")) {
        const parts = dateStr.split("-");
        if (parts[0].length === 4) {
          // YYYY-MM-DD
          date = new Date(dateStr);
        } else {
          // DD-MM-YYYY
          const [day, month, year] = parts;
          date = new Date(`${year}-${month}-${day}`);
        }
      } else {
        date = new Date(dateStr);
      }

      if (isNaN(date.getTime())) {
        console.log("Invalid Date detected:", dateStr);
        return null;
      }

      date.setHours(0, 0, 0, 0);
      console.log(date);
      return date;
    };

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    // Filter the array to include only objects where the arrival date has passed or is today
    console.log("........check.......", check);
    
    const filteredData = check.filter((item) => {
      const arrivalDate = parseDate(item.arrival_date);
      return arrivalDate && arrivalDate <= parseDate(startOfToday.toISOString());
    });

    if (popupState.type == "loan_advance") {
      for (let candidateId of checkedList) {
        const structure = {
          id: candidateId,
          loan_advance_amount: finalObj.loan_advance_amount,
          installment: finalObj.installment,
        };
        body.candidate.push(structure);

        // else if (popupState.type == "status") {
        //   const structure = {
        //     id: candidateId,
        //     status: finalObj.status,
        //   };
        //   body.candidate.push(structure);
        // }
      }
    } else {
      if (popupState.type === "status" && finalObj.status === "ARRIVED") {
        // Check if status is "arrived" and filteredData has candidates
        if (filteredData.length > 0) {
          for (let candidateId of filteredData) {
            const structure = {
              id: candidateId.id,
              status: finalObj.status,
            };
            body.candidate.push(structure);
            console.log("structure to be captured here in console", structure);
          }
        } else {
          // No candidates to update, show error message
          dispatch(
            setAppError({
              msg: "NO CANDIDATES GOT UPDATED...",
            })
          );
          return;
        }
      } else if (popupState.type === "status") {
        // If status is not "arrived", just push all candidates
        for (let candidateId of check) {
          const structure = {
            id: candidateId.id,
            status: finalObj.status,
          };
          body.candidate.push(structure);
          console.log("structure to be captured here in console", structure);
        }
      }
    }
    const response = await postGroupAction(
      body,
      setSubmitLoading,
      setTableData,
      dispatch
    );
    if (response.completed) {
      setTimeout(() => {
        document.getElementById(`arrival_batch_${arrivalBatchId}`)?.click();
        setPopupState({ open: false });
      }, 10);
    }
  };

  useEffect(() => {
    let isEmpty = Object.keys(finalObj).length == 0;
    if (!isEmpty) {
      setDiasble(false);
    } else {
      setDiasble(true);
    }
  }, [finalObj]);

  const statusArray = ["ARRIVED", "NOT ARRIVED", "TRAVELLING"];

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${popupState.open ? "flex" : "hidden"
        }`}
    >
      {showConfirmEditPopup && (
        <ConfirmPopup
          showPromptElement={showConfirmEditPopup}
          setShowPromptElement={setShowConfirmEditPopup}
          submitHandler={handleGroupEdit}
        />
      )}
      <div className="max-w-xl w-full h-auto min-h-[15rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-center w-full">
          <div>
            <h1 className="text-xl font-semibold">Group Action</h1>
            <h2 className="text-sm">Edit Candidate Details</h2>
          </div>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleGroupEdit}>
          {popupState.type == "loan_advance" && (
            <>
              <TextInput
                title="Loan / Advance Amount"
                objKey="loan_advance_amount"
                setFinalObj={setFinalObj}
                required
              />
              <TextInput
                title="Installments"
                objKey="installment"
                setFinalObj={setFinalObj}
                required
              />
            </>
          )}
          {popupState.type == "status" && (
            <ArraySelectInput
              title="Select Status"
              array={statusArray}
              objKey="status"
              setFinalObj={setFinalObj}
              required
            />
          )}
          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitLoading}
              onClick={() => setPopupState({ open: false })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                disable
                  ? "bg-red opacity-50 uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
                  : "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              }
              disabled={submitLoading || disable}
            >
              Submit
              {submitLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
